import React from 'react';
import { NavLink } from 'react-router-dom';

// Pestañas para navegar entre Usuarios y Perfiles.
export default function UsuariosTabs() {
  return (
    <div style={s.tabs}>
      <NavLink to="/usuarios" style={({ isActive }) => ({ ...s.tab, ...(isActive ? s.active : {}) })}>Usuarios</NavLink>
      <NavLink to="/perfiles" style={({ isActive }) => ({ ...s.tab, ...(isActive ? s.active : {}) })}>Perfiles</NavLink>
    </div>
  );
}

const s = {
  tabs: { display: 'flex', gap: 4, marginBottom: 16, borderBottom: '1px solid #334155' },
  tab: { padding: '8px 16px', color: '#94a3b8', textDecoration: 'none', fontSize: 14, fontWeight: 600, borderBottom: '2px solid transparent', marginBottom: -1 },
  active: { color: '#f1f5f9', borderBottom: '2px solid #3b82f6' },
};
